export default "__VITE_ASSET__0dd26e9c__"